<script setup>
import UpdateAvatarForm from "./Partials/UpdateAvatarForm.vue";
import UpdateProfilForm from "./Partials/UpdateProfilForm.vue";
import { useForm } from "@/form";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import Breadcrumb from "@Components/Breadcrumb.vue";

const route = useRoute();
const { t: __ } = useI18n();
const persona = await useForm({ id: route.params.id }).post("personas_edit");
</script>

<template>
    <div>
        <Breadcrumb
            :pages="[
                { name: __('Mes rédacteurs IA'), href: { name: 'personas.index' } },
                { name: __('Modification du rédacteur IA #{id}', { id: persona.id }) },
            ]">
        </Breadcrumb>
        <div class="divide-y divide-gray-300 dark:divide-gray-800">
            <UpdateAvatarForm :persona="persona" />
            <UpdateProfilForm :persona="persona" />
        </div>
    </div>
</template>
